import React from "react";
import { Grid, TextField, Typography, Box } from "@mui/material";
import RequiredLabel from "../../shared/RequiredLabel";

const DateRangeInput = ({
  label,
  valueStart,
  valueEnd,
  nameStart,
  nameEnd,
  onChange,
  isRequired = false,
  errorStart = false,
  errorEnd = false,
  endDisabled = false,
  endFieldAdd = null,
}) => (
  <Box>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
      <Typography sx={{ fontSize: 14 }}>{label}</Typography>
      <RequiredLabel show={isRequired} />
    </Box>

    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} sm={5.5}>
        <TextField
          fullWidth
          name={nameStart}
          type="date"
          value={valueStart}
          onChange={onChange}
          error={errorStart}
        />
      </Grid>

      <Grid item xs={12} sm={1} sx={{ textAlign: "center" }}>
        <Typography sx={{ mx: 1 }}>〜</Typography>
      </Grid>

      <Grid item xs={12} sm={5.5}>
        <TextField
          fullWidth
          name={nameEnd}
          type="date"
          value={valueEnd}
          onChange={onChange}
          error={errorEnd}
          disabled={endDisabled}
        />
      </Grid>

      {endFieldAdd && (
        <Grid item xs={12} sm={5.5} sx={{ ml: "auto", mt: -3 }}>
          <Box>{endFieldAdd}</Box>
        </Grid>
      )}
    </Grid>
  </Box>
);

export default DateRangeInput;
